import { useState, useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import { modal } from '../modal/ModalEmitter';
import CurrencyItem from '../form/misc/CurrencyItem';
import ApiService from '../../services/ApiService';
import { CashTransaction, Customer, Invoice, PaymentDepartment } from './types';
import CashFlow from './CashFlow';

interface Props {
  amount?: number;
  customer: Customer;
  customerNum: string;
  department: PaymentDepartment;
  invoices: Invoice[];
  maxAmount?: number;
  onCollect?: ({ cashTx }: { cashTx: CashTransaction }) => void;
  sessionId?: string;
  userInitials?: string;
}

const PaymentCashCollect = ({
  amount = 0,
  customer,
  customerNum,
  department,
  invoices,
  maxAmount = 0,
  onCollect,
  sessionId,
  userInitials,
}: Props) => {
  const [cashAmount, setCashAmount] = useState<string>(String(amount));

  useEffect(() => {
    setCashAmount(String(amount));
  }, [amount]);

  const handleCashAmountChange = (value: string | undefined = '0') => {
    if (parseFloat(value) > maxAmount) {
      setCashAmount(String(maxAmount));
    } else {
      setCashAmount(value);
    }
  };

  const modalOptions = {
    staticBackdrop: true,
    hidePrint: true,
    hideClose: true,
    headerClass: 'bg-warning text-light',
  };

  const doCollect = () => {
    ApiService.post('/payment/cash', {
      sessionId,
      amount: cashAmount,
      userInitials,
      customer,
      customerNum,
      department,
      invoices,
    })
      .then(response => {
        if (onCollect) {
          onCollect({ cashTx: response.data });
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  const handleCollect = () => {
    modal.confirm({
      ...modalOptions,
      size: 'md',
      title: 'Collect Cash From Customer',
      message: (
        <>
          <CashFlow direction="right" />
          <h4 className="text-center">
            Collect <CurrencyItem>{cashAmount}</CurrencyItem>
          </h4>
        </>
      ),
      callback: doCollect,
    });
  };

  return (
    <Row>
      <Col xs="auto">
        <div style={{ width: '92px' }}>
          <i className="fad fa-money-bill" style={{ color: 'green', fontSize: '40px' }} />
        </div>
      </Col>
      <Col>
        <div className="d-inline-block" style={{ fontSize: '19px' }}>
          <CurrencyInput
            className="form-control d-inline mr-3"
            decimalsLimit={2}
            decimalScale={2}
            defaultValue={cashAmount}
            onValueChange={handleCashAmountChange}
            prefix="$"
            style={{ width: '70px', textAlign: 'right' }}
            value={cashAmount}
          />
          <span className="text-uppercase">Cash</span>
        </div>
      </Col>
      <Col className="text-right">
        <Button className="mr-1" variant="primary" onClick={handleCollect} disabled={!parseFloat(cashAmount)}>
          Collect
        </Button>
      </Col>
    </Row>
  );
};

export default PaymentCashCollect;
